import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import CTASection from '@/components/feature/CTASection';
import SEOHead from '@/components/base/SEOHead';
import HeroSection from './components/HeroSection';
import FivePowersSection from './components/FivePowersSection';
import WhyChooseSection from './components/WhyChooseSection';
import ProcessSection from './components/ProcessSection';

const SITE_URL = (typeof import.meta !== 'undefined' && (import.meta as Record<string, unknown>).env?.VITE_SITE_URL as string) || '';

const jsonLd = {
  '@context': 'https://schema.org',
  '@type': 'Organization',
  '@id': `${SITE_URL}/#organization`,
  name: '得運智科股份有限公司',
  alternateName: '得運智科',
  url: SITE_URL,
  description: '得運智科整合政府輔導資源、AI 應用導入、財稅管理、ESG 永續與產學技術能量，打造更穩健、更智慧、更具競爭力的成長路徑。',
  address: {
    '@type': 'PostalAddress',
    streetAddress: '市政北二路 236 號 20 樓 15 室',
    addressLocality: '台中市',
    addressRegion: '西屯區',
    postalCode: '407',
    addressCountry: 'TW',
  },
  contactPoint: {
    '@type': 'ContactPoint',
    telephone: '+886-909-518-828',
    contactType: 'customer service',
    areaServed: 'TW',
    availableLanguage: ['Chinese'],
  },
  telephone: '+886-909-518-828',
  email: 'abc10616@gmail.com',
  foundingDate: '2024',
  foundingLocation: {
    '@type': 'Place',
    address: {
      '@type': 'PostalAddress',
      addressLocality: '台中市',
      addressCountry: 'TW',
    },
  },
  sameAs: [],
};

export default function HomePage() {
  return (
    <div className="min-h-screen bg-background-50">
      <SEOHead
        title="得運智科股份有限公司 | 企業升級轉型顧問"
        description="得運智科股份有限公司整合政府輔導資源、AI 應用導入、財稅管理、ESG 永續與產學技術能量，協助企業從診斷、規劃、申請、導入到落地執行，打造更穩健、更智慧、更具競爭力的成長路徑。"
        keywords="得運智科, 企業轉型, 數位轉型, AI 顧問, ESG 永續, 財稅管理, 政府資源, 產學合作"
        canonicalPath="/"
        ogType="website"
        jsonLd={jsonLd}
      />
      <Navbar />
      <main>
        <HeroSection />

        {/* Brand Image Banner */}
        <section className="bg-background-50 py-8 md:py-12">
          <div className="w-full px-4 md:px-6 lg:px-8 max-w-5xl mx-auto">
            <div className="rounded-xl overflow-hidden">
              <img
                src="https://storage.readdy-site.link/project_files/3596fc25-c69f-44a2-abe5-af3ab65b5565/29970de2-bbbe-4e45-b720-ebe8008096d2_Gemini_Generated_Image_gtcjl4gtcjl4gtcj.jpg"
                alt="得運智科品牌形象"
                className="w-full h-auto object-cover"
              />
            </div>
          </div>
        </section>

        <FivePowersSection />
        <WhyChooseSection />
        <ProcessSection />
        <CTASection />
      </main>
      <Footer />
    </div>
  );
}